// ABOUTME: Shipper-profile label — carrier logo + the profile name, tinted by shipper type.
// ABOUTME: Colours come from the same source as the stream rules; reused in dropdowns and rows.

import { Box } from "@mui/material";
import { getShipperLogo } from "../../utils/logomapper";
import { getShipperColorSettingsByType } from "../Streams/StreamShipperSettings";

// props: profile ({ type, name }), fullWidth (fill container)
const ShipperProfileLabel = ({ profile, fullWidth = false }) => {
    if (!profile) {
        return null;
    }
    const colorSettings = getShipperColorSettingsByType(profile.type);

    return (
        <Box
            sx={{
                display: fullWidth ? "flex" : "inline-flex",
                width: fullWidth ? 1 : "auto",
                minWidth: 0,
                alignItems: "center",
                gap: 1,
                height: 32,
                pl: 0.5,
                pr: 1.5,
                borderRadius: 4,
                background: colorSettings.streamrule,
                "& svg": { width: 24, height: 24 },
            }}
        >
            {getShipperLogo(profile.type)}
            <Box
                sx={{
                    minWidth: 0,
                    color: colorSettings.base,
                    fontSize: 13,
                    fontWeight: 600,
                    fontFamily: "Roboto, sans-serif",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {profile.name}
            </Box>
        </Box>
    );
};

export default ShipperProfileLabel;
